// extracted by mini-css-extract-plugin
export default {"wrapper":"DarkContainerCard_wrapper__vch1U","title":"DarkContainerCard_title__dXmzx","icon":"DarkContainerCard_icon__Bgb9n","header":"DarkContainerCard_header__YAv7q"};